'use client'

/**
 * Global Error Boundary
 * Captures unhandled exceptions that occur in root layout or Server Components
 * Must include html and body tags
 */

import posthog from 'posthog-js'
import NextError from 'next/error'
import { useEffect } from 'react'

interface GlobalErrorProps {
  error: Error & { digest?: string }
  reset: () => void
}

export default function GlobalError({ error, reset }: GlobalErrorProps) {
  useEffect(() => {
    // Capture exception to PostHog error tracking
    posthog.captureException(error, {
      error_type: 'global_error',
      digest: error.digest,
    })
  }, [error])

  return (
    <html>
      <body>
        <NextError statusCode={0} />
        <button onClick={reset} style={{ marginTop: '20px', padding: '10px' }}>
          Try again
        </button>
      </body>
    </html>
  )
}
